export function getAvioText(getStringRes, key) {
  return getStringRes(key);
}
